module.exports = __webpack_public_path__ + "static/media/dv_app_logo.b79eaa33.png";